<template>
  <v-container fill-height tag="section">
    <v-row class="text-center" justify="center">
      <v-col cols="auto" class="mt-6">
        <v-img :src="require('@/assets/logo.svg')" alt="Logo"></v-img>
        <!-- <h1>404</h1> -->
        <p class="mt-12">الصفحة غير موجودة</p>
        <v-btn color="primary" class="my-6" rounded="lg" dark depressed to="/">
          العودة الى الرئيسية
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PagesError",
};
</script>

<style lang="scss"></style>
